@if (isoCountryLoader.data$|async; as country) {
  @for (fetch of fetches; track trackById(index, fetch); let index = $index) {
    <div class="mb-4">
      <fetch-box-inner [workflow]="workflow"
        [selected]="selectedScrollToFetchId === fetch.id"
        [customer]="customer"
        [addresses]="addresses"
        [fetch]="fetch"
        [frame]="frame"
        [isoCountry]="country"
        [priceIncreaseFlex]="priceIncreaseFlex"
        (statusChange)="statusChange.emit($event)"
        (reloadFetches)="reloadFetches.emit()">
      </fetch-box-inner>
    </div>
  }
} @else {
  <ng-template [ngTemplateOutlet]="loadingOrError.template"></ng-template>
}

<loading-or-error
  #loadingOrError
  [loadingWrapper]="isoCountryLoader"
  [errorMessage]="'Konnte Länder nicht laden'">
</loading-or-error>
